import { render, staticRenderFns } from "./tutorService.vue?vue&type=template&id=ae3c1efc&"
import script from "./tutorService.vue?vue&type=script&lang=js&"
export * from "./tutorService.vue?vue&type=script&lang=js&"
import style0 from "./tutorService.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports